<template>
    <v-card color="transparent" elevation="0">
        <v-progress-linear
            style="position: absolute;"
            class="mx-n4"
            v-if="installmentsLoading"
            indeterminate
            color="black"
        ></v-progress-linear>
        <v-row no-gutters>
            <v-col cols="2">
                <v-icon
                    size="60"
                    :color="
                        selected
                            ? 'black'
                            : 'white'
                    "
                >
                    mdi-package
                </v-icon>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
                <div>
                    <h2
                        :class="
                            selected
                                ? 'text-center font-weight-light'
                                : 'text-center white--text font-weight-light'
                        "
                    >
                        {{ preset.tarifa.name }}
                    </h2>
                </div>
            </v-col>
            <v-col cols="2" class="d-flex justify-end">
                <v-tooltip top v-if="lineType !== 'LINEA_ADICIONAL_SVA' && !isAvatel">
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-switch
                                v-model="crossSell"
                                :disabled="!selected"
                                @click.stop=""
                                inset
                                color="green darken-3"
                            ></v-switch>
                        </div>
                    </template>
                    <span>Cross <v-icon>mdi-arrow-decision-outline</v-icon></span>
                </v-tooltip>
            </v-col>
        </v-row>
        <div>
            <div @click="handler" v-if="lineType !== 'LINEA_ADICIONAL_SVA'">
                <v-combobox
                    :disabled="!selected"
                    :style="selected ? 'background-color: transparent; filter: invert(1);' : ''"
                    :items="availableTelefonosContacto"
                    @change="stepperPhoneNumberChanged"
                    clearable
                    v-model="selectedPhoneNumbers"
                    label="Introduzca Número(s) Asociados"
                    multiple
                    :error-messages="phoneNumberErrorMessages"
                    prepend-icon="mdi-phone-log-outline"
                ></v-combobox>
            </div>
            <div class="d-flex" v-if="lineType !== 'LINEA_ADICIONAL_SVA'">
                <v-select :style="selected ? 'background-color: transparent; filter: invert(1);' : ''"
                    @click="handler"
                    style="width: 50%;"
                    @change="getInstallments()"
                    v-model="sellType"
                    :items="opciones.paquete.tipoVenta"
                    label="Tipo de Venta"
                    item-value="encoded"
                    item-text="human"
                    :disabled="!selected"
                    prepend-icon="mdi-format-list-bulleted-type"
                    clearable
                ></v-select>
                <v-select :style="selected ? 'background-color: transparent; filter: invert(1);' : ''"
                    mandatory
                    @click="handler"
                    @change="changedLineType"
                    style="width: 50%;"
                    v-model="lineType"
                    :items="['LINEA_PRINCIPAL', 'LINEA_ADICIONAL']"
                    label="Tipo de Línea"
                    :disabled="!selected || (!mainLineIsEmpty && lineType !== 'LINEA_PRINCIPAL') || lineType === 'LINEA_ADICIONAL_SVA'"
                    prepend-icon="mdi-format-list-bulleted-type"
                >
                    <template #selection="{item}">
                        {{ item.replace('_', ' ') }}
                    </template>
                    <template #item="{item}">
                        {{ item.replace('_', ' ') }}
                    </template>
                </v-select>
            </div>
            <v-row @click="handler" v-if="lineType !== 'LINEA_ADICIONAL_SVA' && !isAvatel">
                <v-col cols="10">
                    <v-autocomplete
                        :style="selected ? 'background-color: transparent; filter: invert(1);' : ''"
                        v-model="device"
                        :items="terminals"
                        item-text="name"
                        hide-selected
                        @change="deviceChanged"
                        :hint="getCurrentInstallment()"
                        :disabled="!selected || terminals.length <=0"
                        label="Seleccione un Dispositivo"
                        return-object
                        prepend-icon="mdi-cellphone"
                        persistent-hint
                        clearable
                    >
                        <template #selection="{item}">
                                {{ item.name }}
                        </template>
                        <template v-slot:label="{item}">
                                {{ item.name }}
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div 
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-switch
                                    v-model="seguro"
                                    :disabled="!selected || !Boolean(device && device.seguro)"
                                    @click.stop=""
                                    inset
                                    color="green darken-3"
                                ></v-switch>
                            </div>
                        </template>
                        <span>Seguro {{(device && device.seguro) ? (device.seguro.price * (1 + iva/100)).toFixed(2)  : ''}} {{device && device.seguro ? '€' : ''}}<v-icon right>mdi-shield</v-icon></span>
                    </v-tooltip>
                </v-col>
            </v-row>

            <div class="mt-4 d-flex justify-center" @click="handler">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on" 
                            @click="handler" 
                            color="red darken-3" 
                            outlined 
                            small 
                            fab 
                            absolute 
                            right 
                            depressed
                        >
                            <v-icon @click="selected ? model= [] : ''">mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Borrar Todas</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on" 
                            @click="handler" 
                            color="red darken-3" 
                            outlined 
                            small 
                            fab 
                            absolute 
                            left 
                            depressed
                        >
                            <v-badge
                                :content="model.length"
                                :value="model.length"
                                color="red darken-3"
                                overlap
                            >
                                <v-icon>mdi-vector-selection</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    <span> {{model.length}} Seleccionadas</span>
                </v-tooltip>
                <v-slide-group
                    @click.stop=""
                    v-model="model"
                    multiple
                    show-arrows
                >
                    <v-slide-item
                        @click.stop=""
                        v-for="promo, index in availablePromotions"
                        :key="index"
                        v-slot="{ active, toggle }"
                    >
                        <v-card
                            :disabled="!selected"
                            :color="active ?  'green darken-3' : 'grey darken-2'"
                            class="ma-4 d-flex justify-center"
                            height="100"
                            width="120"
                            @click="toggle"
                        >
                            <h4 class="d-flex text-center align-self-center font-weight-light">{{promo.name}}</h4>
                            <h1 v-if="model.indexOf(index) !== -1" style="position:absolute; font-size: 4rem; color: rgba(255, 255, 255, 0.349); left: 0px;">{{model.indexOf(index) + 1}}</h1>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>
            </div>
        </div>
    </v-card color="transparent" elevation="0">
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { clone } from '@/util/libUtil.js';
import defaultPaqueteForm from '@/util/offerConfigurator/defaultPaqueteForm.js';

export default {
	name: 'PresetCard',
	data: () => ({
		proxyPhoneNumbers: [],
		selectedPhoneNumbers: [],
		phoneNumberErrorMessages: [],

		device: null,
		model: [],
		sellType: null,
		lineType: null,

		crossSell: false,
		seguro: false,
	}),
	props: {
		preset: null,
		selected: false,
		save: false,
	},
	methods: {
		deviceChanged() {
			this.seguro = false;
		},
		changedLineType(val) {
			if (val == 'LINEA_PRINCIPAL') this.presetMainUsed = true;
			else this.presetMainUsed = false;
		},
		stepperPhoneNumberChanged(phoneNumbers) {
			let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
			let final = [];
			let otherPackages = [];

			let diff = this.proxyPhoneNumbers.filter(
				(item) => !phoneNumbers.includes(item)
			);
			let equal = this.proxyPhoneNumbers.filter((item) =>
				phoneNumbers.includes(item)
			);
			this.presetPhoneNumbers = this.presetPhoneNumbers.filter(
				(item) => !diff.includes(item)
			);
			this.paquetes.forEach((item) => {
				otherPackages = [...otherPackages, ...item.lineasAsociadas];
			});

			phoneNumbers.forEach((number) => {
				if (!regexTelefono.test(number))
					this.phoneNumberErrorMessages.push(
						`El número ${number} no es válido`
					);
				if (
					(this.presetPhoneNumbers.includes(number) &&
						!equal.includes(number)) ||
					otherPackages.includes(number)
				)
					this.phoneNumberErrorMessages.push(
						`El número ${number} ya está en uso en otro paquete`
					);

				if (this.phoneNumberErrorMessages.length == 0) {
					final.push(number);
				} else {
					setTimeout(() => {
						this.phoneNumberErrorMessages = [];
					}, 2500);
				}
			});

			this.selectedPhoneNumbers = final;
			this.proxyPhoneNumbers = final;
			this.presetPhoneNumbers = [
				...this.presetPhoneNumbers,
				...this.selectedPhoneNumbers,
			];
		},
		getInstallments() {
			if (this.sellType && this.preset.tarifa.id) {
				let installment_type = this.sellType;

				if (installment_type == 'PORTA')
					installment_type = 'PORTABILIDAD';

				if (installment_type == 'MIGRACION')
					installment_type = 'ALTA_NUEVA';

				this.$store.dispatch('configuradorOferta/getInstallments', {
					installment_type: installment_type,
					tarifa: this.preset.tarifa,
				});
			}
		},
		handler(event) {
			if (this.selected) event.stopPropagation();
		},
		checkSelectedPromo(promo) {
			return this.preset.promotion.some((p) => p.id === promo.id);
		},
		getCurrentInstallment() {
			let installment = this.installments.find(
				(installment) => this.device?.id == installment.terminal
			);
			return installment
				? `Inicial: ${installment.initial_price}, Final: ${installment.final_price}, Mensual: ${installment.month_price}`
				: '';
		},
	},
	computed: {
		mainLineIsEmpty() {
			return (
				JSON.stringify(this.mainLine) ==
					JSON.stringify({
						...defaultPaqueteForm,
						tipoLinea: 'LINEA_PRINCIPAL',
					}) && !this.presetMainUsed
			);
		},
		availableTelefonosContacto() {
			let usedTelefonos = this.paquetes.reduce(
				(acc, { lineasAsociadas }) => acc.concat(lineasAsociadas),
				[]
			);
			return this.cliente
				? [
						...this.cliente.telefonosContacto.filter(
							(tel) => !usedTelefonos.includes(tel)
						),
						...this.presetPhoneNumbers,
				  ]
				: [];
		},
		availablePromotions() {
			let promos = [];
			this.preset.tarifa.promotions?.forEach((promo) => {
				let found = this.promotions.find(
					(element) => element.id == promo
				);
				if (found?.is_active == true) promos.push(found);
			});

			return promos;
		},
		presetPhoneNumbers: {
			get() {
				return this.$store.state.configuradorOferta.presetPhoneNumbers;
			},
			set(val) {
				this.$store.commit(
					'configuradorOferta/presetPhoneNumbers',
					val
				);
			},
		},
		presetMainUsed: {
			get() {
				return this.$store.state.configuradorOferta.presetMainUsed;
			},
			set(val) {
				this.$store.commit('configuradorOferta/presetMainUsed', val);
			},
		},
		opciones() {
			return JSON.parse(localStorage.getItem('opciones'));
		},
		...mapGetters('configuradorOferta', [
							'iva',
							'mainLine',
							'additionalPackages',
						]
					),
		...mapGetters('login', [
							'isAvatel'
						]					
					),
		...mapState('configuradorOferta', {
			installmentsLoading: (state) => state.installmentsLoading,
			cliente: (state) => state.cliente,
			tariffs: (state) => state.tariffs,
			operador: (state) => state.operador,
			terminals: (state) => state.terminals,
			promotions: (state) => state.promotions,
			installments: (state) => state.installments,
			paquete: (state) => state.paquete,
			paquetes: (state) => state.atencion.oferta.paquetes,
		}),
	},
	watch: {
		selected() {
			if (!this.selected) {
				this.model = [];
				this.availablePromotions.forEach((promo) => {
					if (this.checkSelectedPromo(promo))
						this.model.push(
							this.availablePromotions.indexOf(promo)
						);
				});
				this.lineType = this.preset.tipoLinea;
				this.device = null;
				if (this.preset.tipoLinea != 'LINEA_ADICIONAL_SVA')
					this.sellType = 'ALTA_NUEVA';
				this.crossSell = this.preset.crossSell;
				this.seguro = false;
				this.selectedPhoneNumbers = [];
			}
		},
		save() {
			if (this.save && this.selected) {
				let preset = clone(this.preset);

				preset['tipoVenta'] = this.sellType;
				preset['promotion'] = this.model.map(
					(promo) => this.availablePromotions[promo]
				);
				preset['cacharro'] = this.device;
				preset['crossSell'] = this.crossSell;
				preset['seguro'] = this.device?.seguro;
				preset['tipoLinea'] = this.lineType;
				preset['installment'] = this.installments.find(
					(installment) => this.device?.id == installment.terminal
				);

				preset['lineasAsociadas'] =
					this.lineType == 'LINEA_ADICIONAL_SVA'
						? this.mainLine.lineasAsociadas
						: this.selectedPhoneNumbers;

				this.$store.state.configuradorOferta.atencion.oferta.paquetes.push(
					preset
				);
			}
		},
	},
	created() {
		this.model = [];
		this.availablePromotions.forEach((promo) => {
			if (this.checkSelectedPromo(promo)) {
				this.model.push(this.availablePromotions.indexOf(promo));
			}
		});

		this.lineType = this.preset.tipoLinea;
		this.device = null;
		if (this.preset.tipoLinea != 'LINEA_ADICIONAL_SVA')
			this.sellType = 'ALTA_NUEVA';
		this.crossSell = this.preset.crossSell;
		this.seguro = false;
		this.selectedPhoneNumbers = [];
	},
};
</script>